import { Injectable } from '@angular/core';

import { InternalEntity } from '@osos/shared/api';
import { ParserBase } from '../../bases/parser/parser-base';

import { InternalEntityPresenterModel } from '@osos/shared/types';
import { FieldFactoryService } from '../../factories/field-factory/field-factory.service';

@Injectable()
export class InternalEntityParserService extends ParserBase<
  InternalEntity,
  InternalEntityPresenterModel
> {
  constructor(private fieldFactoryService: FieldFactoryService) {
    super(InternalEntity, InternalEntityPresenterModel, 1);
  }

  getPresenterModel(model: InternalEntity): InternalEntityPresenterModel {
    const presenter = {
      specificationVersion: this.version,
      id: model.id,
      fields: model.fields?.map((field) =>
        this.fieldFactoryService.createPresenterModel(field),
      ),
      validation: '',
      displayOption: model.displayOption,
    } as InternalEntityPresenterModel;

    return presenter;
  }

  getDataModel(presenter: InternalEntityPresenterModel): InternalEntity {
    const model = {
      id: presenter.id,
      fields: presenter.fields?.map((f) =>
        this.fieldFactoryService.createDataModel(f),
      ),
      validation: presenter.validation,
      displayOption: presenter.displayOption,
    } as InternalEntity;

    return model;
  }
}
